import { Theme } from '@simplybenefits/sb-ui-library';

const colors = Theme.colors;
const fonts = Theme.fonts;
const globalStyles = Theme.globalStyles;

export { colors, fonts, globalStyles };